import getAllOptions from './getAllOptions';
import { computed } from 'mobx';
import { getOwaWorkload } from 'owa-workloads';
var quickOptions = computed(function () {
    return getAllOptions()
        .filter(function (option) {
        return !!option.quickOptionSettings &&
            getOwaWorkload() & option.quickOptionSettings.workloads;
    })
        .sort(function (a, b) { return a.quickOptionSettings.order - b.quickOptionSettings.order; });
});
export default (function () { return quickOptions.get(); });
//# sourceMappingURL=getQuickOptions.js.map